import _ from 'lodash'
import bookmarks from './bookmarks'
import FolderForm from 'scoreboard/components/folder-form'

var BookmarksFolderForm = FolderForm.extend({
	initialize: function(options) {
		// Extend the options with additional properties needed
		// for BookmarksFolderForm
		let extendedOptions = _.extend({}, options, {
			disableMoveButton: true,
			disableCopyButton: true
		})

		// Call the parent initialize method with the extended options
		FolderForm.prototype.initialize.call(this, extendedOptions)

		this.editForm.on('deleted', deletedDescendantBookmarks => {
			_(deletedDescendantBookmarks || [])
				.map(it => it.url)
				.forEach(url => bookmarks.remove(url))
		})
	}
})

export default BookmarksFolderForm
BookmarksFolderForm.__filename__ = 'bookmarks/bookmarks-folder-form.js'
